<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "MV Records",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "MV Records",
      items: [
        {
          text: "Home",
        },
         {
          text: "Apprehension",
        },
        {
          text: "MV Records",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>